import { tokenAmountFromProxy, tokenAmountToProxy } from "./tokenAmount";
export function unsignedInputFromProxy(proxy) {
    return {
        ...proxy,
        value: BigInt(proxy.value),
        assets: proxy.assets.map(a => tokenAmountFromProxy(a))
    };
}
export function unsignedInputToProxy(input) {
    return {
        ...input,
        value: input.value.toString(),
        assets: input.assets.map(a => tokenAmountToProxy(a))
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidW5zaWduZWRJbnB1dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9lcmdvL2VudGl0aWVzL3Vuc2lnbmVkSW5wdXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0EsT0FBTyxFQUFjLG9CQUFvQixFQUFvQixrQkFBa0IsRUFBQyxNQUFNLGVBQWUsQ0FBQTtBQTJCckcsTUFBTSxVQUFVLHNCQUFzQixDQUFDLEtBQXlCO0lBQzlELE9BQU87UUFDTCxHQUFHLEtBQUs7UUFDUixLQUFLLEVBQUUsTUFBTSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUM7UUFDMUIsTUFBTSxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsb0JBQW9CLENBQUMsQ0FBQyxDQUFDLENBQUM7S0FDdkQsQ0FBQTtBQUNILENBQUM7QUFFRCxNQUFNLFVBQVUsb0JBQW9CLENBQUMsS0FBb0I7SUFDdkQsT0FBTztRQUNMLEdBQUcsS0FBSztRQUNSLEtBQUssRUFBRSxLQUFLLENBQUMsS0FBSyxDQUFDLFFBQVEsRUFBRTtRQUM3QixNQUFNLEVBQUUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUNyRCxDQUFBO0FBQ0gsQ0FBQyJ9